import ApplicationReceivedModal from './ApplicationReceivedModal';

export default ApplicationReceivedModal;
